export const DISPARO_EVENTO = 0;

export const CLIENTE_NOTIFICADO = 1;

export const APROVACAO = 2;

export const CONFIRMACAO = 3;

export const PEDIDO_ATENDIDO = 4;

export const OCORRENCIA_ENCERRADA = 5;

export const EventActionStepTypes = {
  DISPARO_EVENTO: DISPARO_EVENTO,
  CLIENTE_NOTIFICADO: CLIENTE_NOTIFICADO,
  APROVACAO: APROVACAO,
  CONFIRMACAO: CONFIRMACAO,
  PEDIDO_ATENDIDO: PEDIDO_ATENDIDO,
  OCORRENCIA_ENCERRADA: OCORRENCIA_ENCERRADA,
};

export const EventActionStep: Record<number, string> = {
  [DISPARO_EVENTO]: "Disparo do Evento",
  [CLIENTE_NOTIFICADO]: "Cliente Notificado",
  [APROVACAO]: "Aguardando Aprovação",
  [CONFIRMACAO]: "Aguardando Confirmação",
  [OCORRENCIA_ENCERRADA]: "Ocorrência Encerrada",
};
